// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".staff-network{width:100%;display:flex;flex-direction:column;gap:24px}.page-content-header__balance{display:flex;gap:10px}.page-content-header__balance__item-right{display:flex;flex-direction:column;justify-content:center;align-items:center;gap:4px}.vendor-image{width:40px;height:40px;border-radius:50%;background-size:cover;background-position:center center;user-select:none}", ""]);
// Exports
module.exports = exports;
